import i18n from '../i18n';

export type SupportedLanguage = 'ja' | 'en';

/**
 * アプリケーションで使用する言語コードへ正規化する。
 * 未設定・未対応の言語は日本語へフォールバックする。
 */
export const normalizeLanguage = (
    locale: string | null | undefined
): SupportedLanguage => {
    const language = locale?.toLowerCase().split(/[-_]/)[0];
    return language === 'en' ? 'en' : 'ja';
};

/**
 * 翻訳ライブラリとブラウザのHTML言語属性を同時に更新する。
 */
export const syncApplicationLanguage = (
    locale: string | null | undefined
): SupportedLanguage => {
    const language = normalizeLanguage(locale);

    document.documentElement.lang = language;
    if (i18n.language !== language) {
        void i18n.changeLanguage(language);
    }

    return language;
};
